import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import HomePage from "./pages/HomePage";
import CooberPedyPage from "./pages/CooberPedyPage";
import FreeMuseumPage from "./pages/FreeMuseumPage";
import UndergroundToursPage from "./pages/UndergroundToursPage";
import GroupToursPage from "./pages/GroupToursPage";
import GroupAccommodationPage from "./pages/GroupAccommodationPage";
import BookTourPage from "./pages/BookTourPage";  
import TourBookingSuccessPage from "./pages/TourBookingSuccessPage";
import OpalStorePage from "./pages/OpalStorePage";
import OnlineStorePage from "./pages/OnlineStorePage";
import AboutOpalPage from "./pages/AboutOpalPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CheckoutPage from "./pages/CheckoutPage";
import NewCheckoutPage from "./pages/NewCheckoutPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import CheckoutCancelledPage from "./pages/CheckoutCancelledPage";
import WebcamPage from "./pages/WebcamPage";
import ContactPage from "./pages/ContactPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import ManagerLoginPage from "./pages/ManagerLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminOrdersPage from "./pages/AdminOrdersPage";
import AdminProductsPage from "./pages/AdminProductsPage";
import AdminBookingsPage from "./pages/AdminBookingsPage";
import AdminLiveDashboardPage from "./pages/AdminLiveDashboardPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import AdminSettingsPage from "./pages/AdminSettingsPage";
import AdminBlackoutDatesPage from "./pages/AdminBlackoutDatesPage";
import AdminCategoriesPage from "./pages/AdminCategoriesPage";
import AdminAnalyticsReportingPage from "./pages/AdminAnalyticsReportingPage";
import NotFoundPage from "./pages/NotFoundPage";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import FloatingSocialMedia from "./components/FloatingSocialMedia";
import UndergroundEdge from "./components/UndergroundEdge";
import HolidayClosurePopup from "./components/HolidayClosurePopup";
import { CartProvider } from "./contexts/CartContext";

function App() {
  // Disable browser's automatic scroll restoration
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  return (
    <HelmetProvider>
      <CartProvider>
        <div className="App">
          <BrowserRouter>
          {/* Holiday Closure Popup - Auto-removes after Jan 9, 2026 */}
          <HolidayClosurePopup />
          <ScrollToTop />
          <Routes>
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/manager" element={<ManagerLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            <Route path="/admin/orders" element={<AdminOrdersPage />} />
            <Route path="/admin/products" element={<AdminProductsPage />} />
            <Route path="/admin/users" element={<AdminUsersPage />} />
            <Route path="/admin/bookings" element={<AdminBookingsPage />} />
            <Route path="/admin/live-dashboard" element={<AdminLiveDashboardPage />} />
            <Route path="/admin/settings" element={<AdminSettingsPage />} />
            <Route path="/admin/blackout-dates" element={<AdminBlackoutDatesPage />} />
            <Route path="/admin/categories" element={<AdminCategoriesPage />} />
            <Route path="/admin/analytics" element={<AdminAnalyticsReportingPage />} />
            
            {/* Main Website Routes */}
            <Route path="/*" element={
              <>
                <Header />
                <main className="min-h-screen">
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/coober-pedy" element={<CooberPedyPage />} />
                    <Route path="/free-museum" element={<FreeMuseumPage />} />
                    <Route path="/underground-tours" element={<UndergroundToursPage />} />
                    <Route path="/group-tours" element={<GroupToursPage />} />
                    <Route path="/group-accommodation" element={<GroupAccommodationPage />} />
                    <Route path="/book-tour" element={<BookTourPage />} />
                    <Route path="/tour-booking-success" element={<TourBookingSuccessPage />} />
                    <Route path="/opal-store" element={<OpalStorePage />} />
                    <Route path="/online-store" element={<OnlineStorePage />} />
                    <Route path="/about-opal" element={<AboutOpalPage />} />
                    <Route path="/opal-store/product/:productId" element={<ProductDetailPage />} />
                    <Route path="/opal-store/checkout" element={<CheckoutPage />} />
                    <Route path="/checkout" element={<NewCheckoutPage />} />
                    <Route path="/opal-store/checkout/success" element={<CheckoutSuccessPage />} />
                    <Route path="/opal-store/checkout/cancelled" element={<CheckoutCancelledPage />} />
                    <Route path="/webcam" element={<WebcamPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    
                    {/* 404 Catch-all route */}
                    <Route path="*" element={<NotFoundPage />} />
                  </Routes>
                </main>
                <Footer />
                <FloatingSocialMedia />
                <UndergroundEdge />
              </>
            } />
          </Routes>
        </BrowserRouter>
      </div>
      </CartProvider>
    </HelmetProvider>
  );
}

export default App;